<template>
  <el-select :size="size"
             v-model="currentValue"
             :multiple="multiple"
             :collapse-tags="collapseTags"
             :filterable="filterable"
             :disabled="disabled"
             :clearable="clearable"
             @change="change($event)" :class="{'width100': width100}">
    <el-option v-for="item in innerDictionary.items" :key="item[innerDictionary.valueKey]"
               :value="item[innerDictionary.valueKey]" :label="item[innerDictionary.textKey]"
               :disabled="item.optionDisabled == null ? false : item.optionDisabled"
               ></el-option>
  </el-select>
</template>

<script>
  import {Dictionary, dictionaryContainer} from '@/util/common/dictionary'

  export default {
    name: "DictionarySelect",
    props: {
      size: {},
      value: {},
      multiple: {},
      collapseTags: {},
      filterable: {},
      clearable: {},
      disabled: {},

      dictionary: {},
      factoryName: {},
      params: {},
      width100: {
        type: Boolean,
        default: true,
      },
      defaultFirst: {
        type: Boolean,
        default: false,
      },
      defaultFirstByOnlyOne: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        currentValue: null,
        innerDictionary: new Dictionary()
      };
    },
    watch: {
      value: {
        deep: true,
        immediate: true,
        handler(value) {
          this.currentValue = value;
        }
      }
    },
    methods: {
      change(event) {
        this.$emit('input', event);
        this.$emit('change', [event, this.innerDictionary.getItem(event)]);
      },
      setDefault() {
        this.$nextTick(() => {
          let values = this.innerDictionary.getValues();
          if (values != null && (this.defaultFirst && values.length >= 1 || this.defaultFirstByOnlyOne && values.length === 1)) {
            this.currentValue = values[0];
            this.change(this.currentValue);
          }
        });
      },
    },
    created() {
      if (this.dictionary != null) {
        this.innerDictionary = this.dictionary;
        this.$emit('loaded', this.innerDictionary);
        this.setDefault();
      } else {
        dictionaryContainer.getDictionary(this.factoryName, this.params).then((result) => {
          this.innerDictionary = result;
          this.$emit('loaded', this.innerDictionary);
          this.setDefault();
        });
      }
    }
  }
</script>

<style scoped>

</style>
